import { AllessehContentQueryBody } from 'hooks/useAllessehContentQuery';
import * as ARTS from './sections/arts';
import * as FREE_EXPRESSION from './sections/freeExpression';
import * as homepage from './sections/homepage';
import { COMMON_QUERY_RULES_CONFIG } from './sections/shared/configs';
import { DEFAULT_QUERY } from '../default';

export type QueryOptionWsjopinion = {
  query: AllessehContentQueryBody;
  label: string;
  type: ARTS.SECTION_ENUM | FREE_EXPRESSION.SECTION_ENUM | null;
  url: string | null;
};

type QueryOptions = {
  [key: string]: QueryOptionWsjopinion[];
};

type QueryConfig = {
  [key: string]: QueryOptions;
};

export const QUERY_CONFIG_WSJOPINION: QueryConfig = {
  'free-expression': {
    SECTION_TOP: [FREE_EXPRESSION.QUERY_CONFIGS.SECTION_TOP],
    SECTION_TOP_FIVE_STORIES: [FREE_EXPRESSION.QUERY_CONFIGS.SECTION_TOP_FIVE_STORIES],
    VIDEO_LIST: [FREE_EXPRESSION.QUERY_CONFIGS.VIDEO_LIST],
    MORE_LIST: [FREE_EXPRESSION.QUERY_CONFIGS.MORE_IN_FREE_EXPRESSION]
  },
  'arts-culture': {
    SECTION_TOP: [{ query: ARTS.ARTS, label: 'Arts & Culture', type: null, url: null }],
    SECTION_TOP_FIVE_STORIES: [{ query: ARTS.ARTS, label: 'Arts & Culture', type: null, url: null }],
    LEADING_AND_SUPPORT_FLASHLINE: [
      { query: ARTS.RECENT_REVIEWS, label: 'Recent Reviews', url: '', type: ARTS.SECTION_ENUM.RECENT_REVIEWS },
      { query: ARTS.REVIEWS_ROUNDUP, label: 'Reviews Roundup', url: '', type: ARTS.SECTION_ENUM.REVIEWS_ROUNDUP }
    ],
    LEADING_AND_SUPPORT: [
      { query: ARTS.BOOKS, label: 'Books', url: 'arts-culture/books', type: ARTS.SECTION_ENUM.BOOKS },
      {
        query: ARTS.FILM,
        label: 'Film',
        url: 'arts-culture/film',
        type: ARTS.SECTION_ENUM.FILM
      },
      {
        query: ARTS.TELEVISION,
        label: 'Television',
        url: 'arts-culture/television',
        type: ARTS.SECTION_ENUM.TELEVISION
      },
      {
        query: ARTS.FOOD_COOKING,
        label: 'Food & Cooking',
        url: 'arts-culture/food-cooking',
        type: ARTS.SECTION_ENUM.FOOD_COOKING
      },
      {
        query: ARTS.WHAT_WATCH,
        label: 'What to Watch',
        url: 'news/books-arts/what-to-watch',
        type: ARTS.SECTION_ENUM.WHAT_WATCH
      },
      { query: ARTS.MUSIC, label: 'Music', url: 'arts-culture/music', type: ARTS.SECTION_ENUM.MUSIC },
      { query: ARTS.FINE_ART, label: 'Fine Art', url: 'arts-culture/fine-art', type: ARTS.SECTION_ENUM.FINE_ART },
      { query: ARTS.THEATER, label: 'Theater', url: 'arts-culture/theater', type: ARTS.SECTION_ENUM.THEATER },
      { query: ARTS.HISTORY, label: 'History', url: 'arts-culture/history', type: ARTS.SECTION_ENUM.HISTORY },
      {
        query: ARTS.APPRECIATION,
        label: 'Appreciation',
        url: 'news/types/appreciation',
        type: ARTS.SECTION_ENUM.APPRECIATION
      },
      {
        query: ARTS.ARCHITECTURE_REVIEW,
        label: 'Architecture Review',
        url: 'news/types/architecture-review',
        type: ARTS.SECTION_ENUM.ARCHITECTURE_REVIEW
      },
      {
        query: ARTS.DANCE_REVIEW,
        label: 'Dance Review',
        url: 'news/types/dance-review',
        type: ARTS.SECTION_ENUM.DANCE_REVIEW
      },
      {
        query: ARTS.OPERA_REVIEW,
        label: 'Opera Review',
        url: 'news/types/opera-review',
        type: ARTS.SECTION_ENUM.OPERA_REVIEW
      },
      {
        query: ARTS.EXHIBITION_REVIEW,
        label: 'Exhibition Review',
        url: 'news/types/exhibition-review',
        type: ARTS.SECTION_ENUM.EXHIBITION_REVIEW
      },
      {
        query: ARTS.CULTURAL_COMMENTARY,
        label: 'Cultural Commentary',
        url: 'news/types/cultural-commentary',
        type: ARTS.SECTION_ENUM.CULTURAL_COMMENTARY
      }
    ],
    VIDEO_LIST: [{ query: ARTS.VIDEO, label: 'Video', type: null, url: null }],
    MORE_LIST: [{ query: ARTS.ARTS, label: 'More in Arts & Culture', type: null, url: null }],
    RELATED_OPINION: [
      {
        query: ARTS.RELATED_OPINION,
        label: 'Related opinion',
        url: '',
        type: ARTS.SECTION_ENUM.RELATED_OPINION
      }
    ]
  },
  homepage: {
    AUTHORS: [{ query: homepage.COLUMNISTS, label: 'Columnists', type: null, url: null }],
    MAJOR_BUCKETS: [
      { query: homepage.LETTERS_TO_EDITORS, label: 'Letters to the Editors', type: null, url: null },
      { query: homepage.EDITORIALS, label: 'Editorials', type: null, url: null },
      { query: homepage.COMMENTARY, label: 'Commentary', type: null, url: null }
    ],
    MAJOR_BUCKETS_SMALL: [
      { query: homepage.COLUMNISTS, label: 'Columnists', type: null, url: null },
      { query: homepage.BEST_OF_WEB, label: 'Best of the Web Today', type: null, url: null }
    ],
    VISUAL_SINGLE: [{ query: homepage.PEPPER_AND_SALT, label: 'Pepper & Salt', type: null, url: null }],
    LEADING_AND_SUPPORT_OPINION: [{ query: homepage.REVIEWS, label: 'Reviews', type: null, url: null }],
    OPINION_PODCASTS: [
      { query: homepage.PODCAST_ALL_THINGS_FEED, label: 'All Things with Kim Strassel', type: null, url: null },
      {
        query: homepage.PODCAST_FREE_EXPRESSION_FEED,
        label: 'Free Expression',
        type: null,
        url: null
      },
      {
        query: homepage.PODCAST_POTOMAC_WATCH_FEED,
        label: 'WSJ Opinion Potomac Watch',
        type: null,
        url: null
      }
    ],
    OPINION_VIDEOS: [{ query: homepage.VIDEOS, label: 'Opinion Videos', type: null, url: null }],
    OPINION_DOCS: [{ query: homepage.OPINION_DOCS, label: 'WSJ Opinion Documentaries', type: null, url: null }],
    OPINION_MORE_LIST: [{ query: homepage.MORE_IN_OPINION, label: 'More in Opinion', type: null, url: null }]
  },
  default: {
    default: [
      { query: { ...DEFAULT_QUERY, query: COMMON_QUERY_RULES_CONFIG }, label: 'Custom Query', type: null, url: null }
    ]
  }
};
